import { Spinner } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import SplitScreenLayout from "components/Layout/SplitScreenLayout";

const Sync: React.FC = () => {
  return (
    <SplitScreenLayout title="Syncing your account" showBack={false}>
      <div>
        <p className="text-gray-900">Your account is being synced. This may take a few moments.</p>
        <Spinner size={128} />
      </div>
    </SplitScreenLayout>
  );
};

export default ApplicationView(Sync);
